<div class="table-container">
  <ng2-smart-table
    [settings]="tableSettings"
    [source]="codesSource"
    (deleteConfirm)="onDeleteConfirm($event)">
  </ng2-smart-table>
</div>
